import { Popover } from "../../../../components/Popover";
import Button from "../../../../components/Button";
import Flex from "../../../../components/Flex";

type YouTubeEmbedPromptProps = {
  open: boolean;
  anchorRect: DOMRect | null;
  onEmbed: () => void;
  onDismiss: () => void;
};

export const YouTubeEmbedPrompt = ({
  open,
  anchorRect,
  onEmbed,
  onDismiss,
}: YouTubeEmbedPromptProps) => (
  <Popover open={open} placement="bottom-start" onClose={onDismiss}>
    <Popover.Trigger>
      {({ ref }) => (
        <button
          ref={ref}
          type="button"
          tabIndex={-1}
          aria-hidden
          style={{
            position: "fixed",
            top: anchorRect?.bottom ?? 0,
            left: anchorRect?.left ?? 0,
            width: anchorRect?.width ?? 0,
            height: 0,
            visibility: "hidden",
            pointerEvents: "none",
          }}
        />
      )}
    </Popover.Trigger>
    <Popover.Content>
      <Flex direction="column" gap={1}>
        <Button appearance="ghost" onClick={onDismiss}>
          Dismiss
        </Button>
        <Button appearance="ghost" onClick={onEmbed}>
          Embed YouTube video
        </Button>
      </Flex>
    </Popover.Content>
  </Popover>
);

YouTubeEmbedPrompt.displayName = "YouTubeEmbedPrompt";
